import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "../../lib/api";

export const InstagramLink = ({ testid, withHandle = false, className = "" }) => (
  <a
    href={INSTAGRAM_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    aria-label="00shot on Instagram"
    className={`inline-flex items-center gap-2 text-lime hover:drop-shadow-[0_0_12px_rgba(0,212,54,0.7)] transition-[filter] ${className}`}
  >
    <Instagram className="w-6 h-6" strokeWidth={2.2} />
    {withHandle && <span className="font-cond font-bold tracking-wider text-lg">@00shot</span>}
  </a>
);
